export default __webpack_public_path__ + "static/intro-tile-2-tagline-74e67e4ac7d77c11dab1dfe303f480ad.jpg";